import { Api } from "./Api.class";
const endpoint = "users";
const UsersAPI = new Api(endpoint);
export default UsersAPI;
